import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { __prod__ } from 'shared/constants/common';

export function initSentry() {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],
    enabled: !!process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // debug: !__prod__,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: __prod__ ? 0.2 : 1.0,
    beforeSend(event, hint) {
      // Modify the event here
      // if (event.user) {
      //   // Don't send user's email address
      //   delete event.user.email;
      // }

      // const error = hint.originalException;
      // if (
      //   error &&
      //   error.message &&
      //   error.message.match(/database unavailable/i)
      // ) {
      //   event.fingerprint = ['database-unavailable'];
      // }

      return event;
    },
    ignoreErrors: [
      // "Can't find variable: thangden",
    ],
    denyUrls: [
      // /graph\.facebook\.com/i,
      /localhost:3000/i,
    ],
    normalizeDepth: 5,
  });
}

export default Sentry;
